<template>
  <div class="modal-header">
    <h5 class="modal-title">{{ row.subject }}</h5>
    <button type="button" class="btn-close" data-coreui-dismiss="modal" aria-label="Close" />
  </div>
</template>

<script>
export default {
  name: "MailModalTitle",
  props: {
    row: {
      type: Object,
      required: true,
    },
  }
}
</script>
